import React from "react";
import "components/Tribe/Friends/UserDetail/FriendNewsfeed/Reaction.css";
import TextTheme from "components/General/Text/TextTheme";
import Image from "react-bootstrap/Image";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

/*Copied and modified from https://material-ui.com/components/tooltips/#interactive*/
const UserListTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "#1a3867",
    border: "1px solid #bebebe",
    fontSize: 12,
  },
}))(Tooltip);

function UserReaction(props) {
  return (
    <div className="user_reaction_container">
      <div className="user_reaction_content">
        <Image src={props.image} />
        <UserListTooltip
          title={props.userList}
          enterDelay={700}
          placement="top"
          style={{ fontSize: "20px" }}
        >
          {/* <div style={{ paddingTop: "20%" }}> */}
            <TextTheme
              className="text_white text_small text_bold"
              message={props.count}
            />
          {/* </div> */}
        </UserListTooltip>
      </div>
    </div>
  );
}

export default UserReaction;
